import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {VapQuestion} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';

declare var $: any;
@Component({
    selector: 'app-vaps-general-six',
    templateUrl: './vaps-general-six.component.html',
    styleUrls: ['./vaps-general-six.component.scss'],
    standalone: false
})
export class VapsGeneralSixComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: VapQuestion;
  @Input() currentVap: QuotePageDataVaps;
  @Input() addAnother = false;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<any>();
  @Output() addAnotherChanged = new EventEmitter<boolean>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();

  maskOptions: NgxCurrencyConfig;
  vaps = [];

  constructor(public questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAnother?.currentValue === true) {
      this.addAnotherItem();
      this.addAnotherChanged.emit(false);
    }
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answers) {
        this.question.answers_parsed = JSON.parse(this.question?.answers);
      }
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(this.vaps);
      this.vaps = [];
      this.getProductDetails();
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.currentVap?.value_max,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  getProductDetails(): any {
    if (this.getVapPrice(this.currentVap)) {
      for (const v of this.collation_vaps) {
        const item = {
          description: [],
          amount: '',
          name: '',
          surname: '',
          session_item_id: '',
          price: 0,
          show: true
        };
        if (this.currentVap?.product_vaps_id === v?.product_vaps_id && v?.select === 1) {
          item.description = v?.detail.substring(0, v.detail.indexOf('|')).split('_');
          item.session_item_id = v?.session_item_id ? v?.session_item_id : '1';
          item.price = v?.premium ? v?.premium : 0;
          item.show = false;

          if (this.question?.answers_parsed?.length) {
            for (const i of this.question?.answers_parsed) {
              const answer = i?.answer?.split('|');
              if (answer?.length && answer[0].toString() === v?.session_item_id?.toString()) {
                item.name = answer[1];
                item.surname = answer[2];
                item.amount = answer[3]?.toString();
              }
            }
          }

          this.vaps.push(item);
        }
      }
    } else {
      this.addAnotherItem();
    }
  }

  addAnotherItem(): void {
    let item_id = 1;
    if (this.vaps?.length) {
      item_id = this.vaps?.length + 1;
    }
    const item = {
      description: [],
      amount: '',
      name: '',
      surname: '',
      session_item_id: item_id.toString(),
      price: 0,
      show: true
    };
    this.vaps.push(item);
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  calculate(): void {
    for (let i = 0; i < this.vaps?.length; i++) {
      this.onChange(i, 1);
    }
  }

  onChange(index: number, action: number): void {
    if (this.vaps[index]?.name && this.vaps[index]?.surname && this.vaps[index]?.amount) {
      if (action === 1) {
        this.questionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.vaps[index]?.name + '|' + this.vaps[index]?.surname + '|' + this.vaps[index]?.amount;
      this.question.answer = answer;
      this.questionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, this.vaps[index]?.session_item_id, answer, 0, '')
        .subscribe(() => {
            this.questionService.calcPremiumAddons(this.currentVap?.product_vaps_id, this.vaps[index]?.session_item_id, this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  p?.forEach(item => {
                    this.vaps[index].price = item?.premium;
                  });
                  this.amountChanged.emit(this.vaps);
                  this.questionService.spinner(false);
                  this.questionService.resetVaps(false);
                }
              });

        });
    } else {
      this.vaps[index].price = 0;
      this.amountChanged.emit(this.vaps);
    }
  }
}
